/* jshint maxcomplexity: 5, maxparams: 3, maxdepth: 2, maxstatements: 10 */
module.exports = (function() {
    'use strict';
    var errorsScheme = {
        id: '',
        type: '',
        validationResult: '',
        description: '',
    };

    return Backbone.Model.extend({
        defaults: errorsScheme,

        initialize: function() {
            this.buildType();
        },

        // Builds the correct type like type_empty to match correctly with widget options error message's type
        buildType: function() {
            var validationResult = this.get('validationResult');
            if (validationResult) {
                this.set('type', this.get('type') + (validationResult === 'invalid' ? '_invalid' : '_empty') );
            }
        },
    });
})();
